const keys_prod = {
    config: {
        apiKey: "AIzaSyB74QJGn872uBclmoVrwXn5t3KhtJcC8bg",
        authDomain: "petanque-app.firebaseapp.com",
        databaseURL: "https://petanque-app.firebaseio.com",
        projectId: "petanque-app",
        storageBucket: "petanque-app.appspot.com",
        messagingSenderId: "YOUR_MESSAGING_SEND_ID",
        appId: "1:696068728917:web:f5b62ca7f7e99656564cdc",
        measurementId:  "G-VMW5SWP3MB"
    },

    /*stripe_prod: {
        pk: "pk_live_NtRub653l4BgDRCKSYST9O9s00OUEvxnkb",
        tax_id: "txr_1HXUjCJfciPMt21YzJLhyPGN"
    },*/
    stripe: {
        pk: "pk_live_51HxA56Jv2Qkf1GvfsJm54OMvtltfKkjr0nzaSRy6Dw0TAO8un6nZyLU4cCwk94ufNQA9iMMKxWxk0RZ5SKycMN5100u8F4N685",
        tax_id: "txr_1IwpbgJv2Qkf1Gvf642phbMN",
        product: "prod_IwD7c0MxoqCxpi",
        price_concours_id: "price_1IwlKFJv2Qkf1GvfVosWLHQy",
        price_pack20_id: "price_1IwlJxJv2Qkf1GvfhCz6MNaR", 
        price_pack52_id: "price_1IwlJjJv2Qkf1GvflVJTIfnd" 
        
    },
    
    //siteKeyCaptcha: "6Lfsy9MZAAAAAFOC5jNz5W3SIVhYu6FHn_IxsGM8"
    siteKeyCaptcha: "6LeeCk8aAAAAANJmwgwmMtTnf6uPTYA9EZNyPXoJ",
    siteKeyCaptchaProd: "6LeeCk8aAAAAANJmwgwmMtTnf6uPTYA9EZNyPXoJ",

    siteKeyCaptchaV3: "6LfGBrAaAAAAALz8v1AVl56tz164BGJDnTmehSSv"
}
export default {
    keys: keys_prod
  };